export default __webpack_public_path__ + "static/media/space-time.e6f0015b.png";